import { render, staticRenderFns } from "./starCloud.vue?vue&type=template&id=0d923a47&scoped=true"
import script from "./starCloud.vue?vue&type=script&lang=js"
export * from "./starCloud.vue?vue&type=script&lang=js"
import style0 from "./starCloud.vue?vue&type=style&index=0&id=0d923a47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d923a47",
  null
  
)

export default component.exports